import React, {useEffect, useRef} from 'react'
import * as THREE from 'three'
import {Lut} from "three/examples/jsm/math/Lut";
import './Scene.css';
import Legends from "./Legends/Legends";

function SceneLegend({type, legends, maps, max, min}) {
    const mount = useRef(null);

    useEffect(() => {

        let width = mount.current.clientWidth;
        let height = mount.current.clientHeight;
        let frameId;

        const scene = new THREE.Scene();

        const camera = new THREE.PerspectiveCamera(
            70,
            width / height,
            0.1,
            10000
        );

        const renderer = new THREE.WebGLRenderer({
            antialias: true,
            preserveDrawingBuffer: true
        });
        renderer.outputEncoding = THREE.sRGBEncoding;
        renderer.setSize(width, height);

        camera.position.z = 0.5;
        camera.position.x = 0;
        camera.position.y = 0;

        const lut = new Lut();
        lut.addColorMap("rainbowInvert",
            [[0.0, "#960c0c"], [0.3, "#960c0c"], [0.6, "#f50f0f"], [0.7, "#ff3e1c"], [0.75, "#fca503"], [0.775, "#fcc603"], [0.8, "#fffb00"], [0.825, "#fcc603"], [0.85, "#0dff00"], [0.9, "#00ffff"], [0.95, "#0000ff"], [1, "#0000ff"]]
        );
        lut.setColorMap('rainbowInvert');
        const sprite = new THREE.Sprite(new THREE.SpriteMaterial({
            map: new THREE.CanvasTexture(lut.createCanvas())
        }));
        sprite.scale.x = 0.05;
        sprite.scale.y = 0.5;
        scene.add(sprite);

        const renderScene = () => {
            renderer.render(scene, camera)
        }

        const handleResize = () => {
            width = mount.current.clientWidth;
            height = mount.current.clientHeight;
            renderer.setSize(width, height);
            camera.aspect = width / height;
            camera.updateProjectionMatrix();
            renderScene()
        }

        const animate = () => {
            renderScene();
            camera.updateMatrixWorld();
            frameId = window.requestAnimationFrame(animate);
        };

        const start = () => {
            if (!frameId) {
                frameId = requestAnimationFrame(animate);
            }
        };

        const stop = () => {
            cancelAnimationFrame(frameId);
            frameId = null
        };

        mount.current.appendChild(renderer.domElement);
        window.addEventListener('resize', handleResize);
        start();

        return () => {
            stop();
            window.removeEventListener('resize', handleResize);
        };

    }, []);

    return (
        <div className="scene-legend"
             ref={mount}
             style={{width: '61px', height: '250px'}}>
            <Legends title={legends}/>
            {type === "ffr" ?
                <div className="legend_num">
                    <p className="mb-0 legend-item legend-item1">1,0 - </p>
                    <p className="mb-0 legend-item legend-item2">0,8 - </p>
                    <p className="mb-0 legend-item legend-item3">0,6 - </p>
                    <p className="mb-0 legend-item legend-item4">0,3 - </p>
                    <p className="mb-0 legend-item legend-item5">0,0 - </p>
                </div> :
                <div className="legend_num">
                    <p className="mb-0 legend-item legend-item1">{Math.floor(max)} - </p>
                    <p className="mb-0 legend-item legend-item4">{Math.floor(min)} - </p>
                </div>
            }
        </div>
    );
}

export default SceneLegend;